/* eslint-disable no-undef */

import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import parse from 'html-react-parser'
import { Box, Dialog, DialogContent, DialogTitle, Button } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SelectCompanies from '../../../../client/LeadSparkPanel/components/SelectCompanies'

const styles = theme => ({
    root: {
        marginBottom: theme.layoutAlias === 'exclusive' ? theme.spacing(4) : null,
        fontFamily: "'Plus Jakarta Sans', sans-serif"
    },
    defaultContainer: {
        paddingTop: theme.layoutAlias === 'exclusive' ? 0 : theme.layoutAlias === 'premium-exclusive' ? 15 : 24,
        marginBottom: 5,
        textAlign: 'center',
        fontSize: 11,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        color: '#7a8a82!important',
        marginTop: 'auto',
        width: '100%',
        fontFamily: "'Plus Jakarta Sans', sans-serif"
    },
    disclaimerContainer: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
        '& h3, & h4, & p': {
            margin: 0
        }
    },
    smallDisclaimerContainer: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        fontSize: '0.8rem',
        color: theme.termsColor ? theme.termsColor + '!important' : 'rgba(0,0,0,0.41)!important',
        '& h3, & h4, & p': {
            margin: 0
        }
    },
    link: {
        color: '#7a8a82!important',
        textDecoration: 'none',
        transition: 'color 0.2s ease',
        '&:hover': {
            color: '#205a40!important'
        }
    },
    howDataIsUsedWrapper: {
        marginTop: theme.spacing(1.25),
        fontSize: '0.85rem',
        color: 'rgba(0,0,0,0.81)'
    },
    howDataIsUsedTitle: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center'
    },
    howDataIsUsedContent: {
        fontSize: '0.85rem',
        color: 'rgba(0,0,0,0.81)'
    },
    linkAlternative: {
        color: theme.termsColor ? theme.termsColor + '!important' : 'rgba(0,0,0,0.41)!important',
        textDecoration: 'none',
        '&:hover': {
            cursor: 'pointer'
        }
    }
})

function getTermsLabel() {
    if (process.env.MIX_APP_COUNTRY === 'denmark') {
        return 'Vilkår'
    }
    if (process.env.MIX_APP_COUNTRY === 'sweden') {
        return 'Villkor'
    }
    return 'Palvelun käyttöehdot'
}

function getPrivacyPolicyLabel() {
    if (process.env.MIX_APP_COUNTRY === 'denmark') {
        return 'Fortrolighedspolitik'
    }
    if (process.env.MIX_APP_COUNTRY === 'sweden') {
        return 'Integritetspolicy'
    }
    return 'Tietosuoja'
}

function getRulesLabel() {
    if (process.env.MIX_APP_COUNTRY === 'denmark') {
        return 'Regler'
    }
    if (process.env.MIX_APP_COUNTRY === 'sweden') {
        return 'Regler'
    }
    return 'Säännöt'
}

function handleOpen() {
    setSelectCompaniesOpenSelectCompanies(true)
}

class Terms extends Component {
    state = {
        howDataIsUsedShown: false,
        selectCompaniesOpen: false
    }

    toggleHowDataIsUsedShown = () => {
        this.setState({ howDataIsUsedShown: !this.state.howDataIsUsedShown })
    }

    openSelectCompanies = () => {
        this.setState({ selectCompaniesOpen: true })
    }

    closeSelectCompanies = () => {
        this.setState({ selectCompaniesOpen: false })
    }

    render() {
        const { howDataIsUsedShown, selectCompaniesOpen } = this.state
        const { classes, domain, paddingTop, theme, layout } = this.props

        return (
            <div className={classes.root} id={'terms'}>
                {(layout === 'premium-exclusive' || layout === 'full') && (
                    <Box className={classes.howDataIsUsedWrapper}>
                        <Box onClick={this.toggleHowDataIsUsedShown} className={classes.howDataIsUsedTitle}>
                            <Box mr={1} ml={-2}>
                                <FontAwesomeIcon
                                    size={'xs'}
                                    className={classes.icon}
                                    icon={['far', howDataIsUsedShown ? 'chevron-right' : 'chevron-down']}
                                />
                            </Box>
                            <Box>Miten tietojani käytetään?</Box>
                        </Box>
                        {howDataIsUsedShown && <Box className={classes.howDataIsUsedContent}>{parse(theme.howDataIsUsed ?? '')}</Box>}
                    </Box>
                )}
                {process.env.MIX_APP_COUNTRY === 'denmark' ? (
                    <div className={classes.disclaimerContainer}>{domain.disclaimer && parse(domain.disclaimer)}</div>
                ) : (
                    <>
                        <div className={classes.defaultContainer} style={{ paddingTop: paddingTop ?? null }}>
                            <a href={domain.main} className={classes.link} target="blank">
                                {domain.label}
                            </a>{' '}
                            |{' '}
                            <a href={domain.terms} className={classes.link} target="blank">
                                {getTermsLabel()}
                            </a>{' '}
                            |{' '}
                            <a href={domain.privacy_policy} className={classes.link} target="blank">
                                {getPrivacyPolicyLabel()}
                            </a>
                            {domain.direct_marketing_policy && (
                                <>
                                    {' | '}
                                    <a href={domain.direct_marketing_policy} className={classes.link} target="blank">
                                        {getRulesLabel()}
                                    </a>
                                </>
                            )}
                            {process.env.MIX_APP_COUNTRY === 'sweden' && (
                                <>
                                    {' '}
                                    |{' '}
                                    <a onClick={this.openSelectCompanies} role={'button'} className={classes.linkAlternative} target="blank">
                                        Samarbetspartners
                                    </a>
                                    <SelectCompanies open={selectCompaniesOpen} onClose={this.closeSelectCompanies} />
                                </>
                            )}
                        </div>
                        {domain.disclaimer && <div className={classes.smallDisclaimerContainer}>{parse(domain.disclaimer)}</div>}
                    </>
                )}
                {layout === 'center' && theme?.howDataIsUsed && (
                    <Box className={classes.howDataIsUsedWrapper}>
                        <Box className={classes.howDataIsUsedContent}>{parse(theme.howDataIsUsed ?? '')}</Box>
                    </Box>
                )}
            </div>
        )
    }
}

export default withStyles(styles)(Terms)
